import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import type { IApiErrorPlain } from '@platform/core/types';
import { ApiError } from '@platform/dao';

const TAGS = [
  'Catalog', 'Module', 'RecordList', 'Record', 'Stats', 'Comments', 'Files', 'Assignments', 'History', 'Links', 'Workspaces', 'Tags', 'Views', 'Me', 'Inbox', 'Recent',
  'Favourites', 'Settings', 'Roles', 'Paths', 'Override', 'GlobalCatalog', 'GlobalOverride',
] as const;

/** Базовий API RTK Query: транспорт — DAO (queryFn), кеш — за тегами. */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery<IApiErrorPlain>(),
  tagTypes: TAGS,
  keepUnusedDataFor: 60,
  endpoints: () => ({}),
});

/** Обгортає виклик DAO у формат queryFn (data | error). */
export async function run<T>(fn: () => Promise<T>): Promise<{ data: T } | { error: IApiErrorPlain }> {
  try {
    return { data: await fn() };
  } catch (e) {
    return { error: ApiError.fromUnknown(e) };
  }
}

export const recordTag = (rt: string, id: string) => ({ type: 'Record' as const, id: `${rt}:${id}` });
export const listTag = (rt: string) => ({ type: 'RecordList' as const, id: rt });
export const statsTag = (rt: string) => ({ type: 'Stats' as const, id: rt });
